import { usePrevious } from '@ps/web-shared-components';
import { useEffect } from 'react';
import { useLocation } from 'react-router';

const useOnNavigate = (callback: (pathname: string) => void) => {
  const location = useLocation();
  const previousPathnameRef = usePrevious(location.pathname);

  useEffect(() => {
    if (location.pathname !== previousPathnameRef) {
      callback(location.pathname);
    }
    // Don't rebuild when the callback changes.
    // This allows for passing arrow functions in rather than using useCallback
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);
};

export default useOnNavigate;
